import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = {
	strategies: string[];
};

export const StrategyList = ({ strategies }: Props) => {
	const theme = useAppTheme();
	return (
		<Box width="100%" gap={8}>
			{strategies.map((strategy, index) => (
				<Box
					key={strategy}
					width="100%"
					flexDirection="row"
					alignItems="flex-start"
					gap={8}
				>
					<Box
						width={22}
						height={22}
						marginTop={2}
						borderRadius={11}
						borderWidth={1}
						borderColor={theme.colors.outlineVariant}
						alignItems="center"
						justifyContent="center"
					>
						<Text
							variant="labelSmall"
							style={{ color: theme.colors.onSurfaceVariant }}
						>
							{index + 1}
						</Text>
					</Box>
					<Box flex={1}>
						<Text
							variant="bodyMedium"
							style={{ color: theme.colors.onSurfaceVariant }}
						>
							{strategy}
						</Text>
					</Box>
				</Box>
			))}
		</Box>
	);
};
